export default __webpack_public_path__ + "static/media/Header12345copy.f5a20c41.png";